export const environment = {
  base_url: 'https://bmd-api.services.calibrantenergy.com/bmd/',
  brands: {
    calibrant: {
      baseUrl: '/',
    },
  },
  defaults: {
    brand: 'calibrant',
    locale: 'en-us',
  },
  production: true,
  x_api_key: 'iXQ0MVdUSE8k72rETVbaH273BMROzJPq33T1EhWc',
};
